import React, { useContext } from "react";
import { Link } from "react-router-dom";

import { GlobalContext } from "../../../app/providers/GlobalState";

import { Dropdown } from "antd";

import {
    iconVideo,
    iconAudio,
    iconHtml,
    iconPdf,
    iconQuestionario,
    iconAvaliacao,
    iconDownload,
    iconTrabalhoIndividual,
    iconTrabalhoGrupo,
    iconTrabalhoColaborativo,
    iconLink,
    iconSumario,
    iconSessaoPresencial,
    iconPasta,
    iconQuestionarioProgresso,
    iconQuestionarioDirigido,
    iconPresencas
} from "../../../assets/tipoDeConteudos";

const iconesPorTipo = {
    1: { icon: iconVideo }, // Vídeo
    2: { icon: iconAudio }, // Áudio
    3: { icon: iconHtml }, // HTML
    12: { icon: iconHtml }, // HTML EMBEBIDO
    4: { icon: iconPdf }, // PDF
    5: { icon: iconQuestionario }, // QUESTIONÁRIO
    6: { icon: iconAvaliacao }, // AVALIAÇÃO
    7: { icon: iconDownload }, // DOWNLOAD
    8: {
        // Trabalho
        icon: aula => {
            switch (aula.tipo_trabalho) {
                case "INDIVIDUAL":
                    return iconTrabalhoIndividual;
                case "GRUPO":
                    return iconTrabalhoGrupo;
                default:
                    return iconTrabalhoColaborativo;
            }
        }
    },
    9: { icon: iconLink }, // LINK
    10: { icon: iconSumario }, // SUMÁRIO
    11: { icon: iconSessaoPresencial }, // SESSÃO PRESENCIAL
    13: { icon: iconPasta }, // PASTA
    14: { icon: iconQuestionarioProgresso }, // QUESTIONÁRIO DE PROGRESSO
    15: { icon: iconQuestionarioDirigido }, // QUESTIONÁRIO DIRIGIDO
    17: { icon: iconPresencas } // PRESENCAS
};

const Tarefa = ({ aula, inicioUrl, index, botoesVisiveis, modulo, montarMenuAula, onClink }) => {
    const context = useContext(GlobalContext);

    const { id, nome, tipo_Recurso } = aula;

    const tipoId = tipo_Recurso.id;
    const tipoConfig = iconesPorTipo[tipoId];

    if (!tipoConfig) return null;

    const icone = typeof tipoConfig.icon === "function" ? tipoConfig.icon(aula) : tipoConfig.icon;

    const url = `${inicioUrl}${tipo_Recurso.url}`;

    const acesso = context.acessos?.find(x => x.func === 18);

    const overlayMenu =
        typeof index === "number"
            ? montarMenuAula(modulo.id, modulo.competencias, index, aula)
            : montarMenuAula(modulo.id, modulo.competencias, aula);

    const podeVerMenu = botoesVisiveis && !modulo.conteudos_stepforma && (acesso?.update || acesso?.delete);

    return (
        <>
            {/* DESKTOP */}
            <Link to={url} className="link-licao-desktop" disabled={!acesso?.read} onClick={() => onClink(aula.id)}>
                <span className="start" title={tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                    <img className="tarefa-icon" src={icone} />
                </span>
                <span className="licao">
                    {nome}
                    {podeVerMenu && (
                        <Dropdown overlay={overlayMenu} placement="bottomLeft">
                            <Link to="#" className="botao-icon-configs-tarefa">
                                <i className="fas fa-cog" />
                            </Link>
                        </Dropdown>
                    )}
                </span>
            </Link>

            {/* MOBILE */}
            <Link to={url} className="link-licao-mobile" disabled={!acesso?.read} onClick={() => onClink(id)}>
                <div className="licao-bloco-esquerda">
                    <span className="start" title={tipo_Recurso.nome} style={{ width: 30, height: 30 }}>
                        <img className="tarefa-icon" src={icone} />
                    </span>
                    <span className="licao">{nome}</span>
                </div>
                <div className="licao-bloco-direita">
                    {podeVerMenu && (
                        <Dropdown overlay={overlayMenu} placement="bottomLeft">
                            <Link to="#" className="botao-icon-configs-tarefa">
                                <i className="fas fa-cog" />
                            </Link>
                        </Dropdown>
                    )}
                </div>
            </Link>
        </>
    );
};

export default Tarefa;
